import React from 'react';
import { Icon } from './Icon.js';
export const IconCopyFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8.25,12H2.25c-1.24,0-2.25-1.009-2.25-2.25V3.75c0-.414.336-.75.75-.75s.75.336.75.75v6c0,.414.337.75.75.75h6c.414,0,.75.336.75.75s-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("rect", { x: "2.5", width: "9.5", height: "9.5", rx: "2.25", ry: "2.25", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCopyFill12.js.map